import type { AdminDeviceRow } from "../../api/types";
import { StaffAction } from "./shared";

/** Disable / enable / revoke buttons for one device (docs/07 §3), support sees them disabled. */
export function DeviceActions({
  device,
  canMutate,
  onAction,
}: {
  device: AdminDeviceRow;
  canMutate: boolean;
  onAction: (id: string, action: "revoke" | "disable" | "enable") => void;
}) {
  if (device.status === "revoked") return null;
  return (
    <span className="flex gap-2">
      {device.status === "active" ? (
        <StaffAction
          allowed={canMutate}
          onClick={() => onAction(device.id, "disable")}
        >
          Disable
        </StaffAction>
      ) : (
        <StaffAction
          allowed={canMutate}
          onClick={() => onAction(device.id, "enable")}
        >
          Enable
        </StaffAction>
      )}
      <StaffAction
        allowed={canMutate}
        variant="danger"
        onClick={() => onAction(device.id, "revoke")}
      >
        Revoke
      </StaffAction>
    </span>
  );
}
